module.exports = __webpack_public_path__ + "img/resources-768.ebc3a773.jpg";